import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Rotas } from 'src/app/core/rotas';
import { PublicoAlvo } from '../../core/publico-alvo';
import { BaseService } from '../base/base.service';


@Injectable({
  providedIn: 'root'
})
export class PublicoAlvoService extends BaseService<PublicoAlvo> {
  
  constructor(http: HttpClient) {
    super(http, Rotas.PUBLICOS_ALVOS);
  }

  getPublicoAlvoById(id: number) {
    return this.http.get(`${Rotas.PUBLICOS_ALVOS}${id}`);
  }

  getPublicoAlvoAtividadeById(id: number) {
    return this.http.get(`${Rotas.PUBLICOS_ALVOS}atividade/${id}`);
  }

  getAllCombo() {
    return this.http.get(`${Rotas.PUBLICOS_ALVOS}combo`);
  }

}

